export const GTM_ID = process.env.REACT_APP_ENVIRONMENT === 'main'
    ? 'GTM-T5J56JBP'
    : undefined;